import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HomeContainer = styled.div`
  flex: 1;
`;

const Hero = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
              url('https://images.unsplash.com/photo-1501443762994-82bd5dace89a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-position: center;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
`;

const HeroContent = styled.div`
  max-width: 800px;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const Button = styled(Link)`
  background-color: #ff6b6b;
  color: white;
  padding: 1rem 2rem;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff5252;
  }
`;

const Features = styled.div`
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const Feature = styled.div`
  text-align: center;
  padding: 2rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const FeatureText = styled.p`
  color: #666;
  line-height: 1.6;
`;

function Home() {
  return (
    <HomeContainer>
      <Hero>
        <HeroContent>
          <Title>Welcome to Essex Ice Cream</Title>
          <Subtitle>Handcrafted ice cream made with love in Essex, MA</Subtitle>
          <Button to="/menu">View Our Menu</Button>
        </HeroContent>
      </Hero>
      
      <Features>
        <Feature>
          <FeatureTitle>Homemade Daily</FeatureTitle>
          <FeatureText>Our ice cream is made fresh every day using local ingredients and traditional recipes.</FeatureText>
        </Feature>
        <Feature>
          <FeatureTitle>Local Ingredients</FeatureTitle>
          <FeatureText>We source our ingredients from local Essex farms to ensure the highest quality.</FeatureText>
        </Feature>
        <Feature>
          <FeatureTitle>Unique Flavors</FeatureTitle>
          <FeatureText>Try our seasonal specialties and unique flavor combinations.</FeatureText>
        </Feature>
      </Features>
    </HomeContainer>
  );
}

export default Home;
